import React from "react";
import { useNavigate } from "react-router-dom";
import TodayTotalVolunteerList from "../../components/DashboardInfo/TodayTotalVolunteerList";
import { ThemButton } from "../../components/Login/Login.style";
import { MainDiv } from "../../components/Profile/Profile.style";
import { SearchAddDiv } from "../../components/style/Table.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const TodayAddVolunteerPage = () => {
  const navigate = useNavigate();
  const moveDashboard = () => {
    navigate("/");
  };
  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Today Total Volunteer Report</VolunteerHeading>
        <div
          style={
            {
              // display: "flex",
              // justifyContent: "center",
            }
          }
        >
          <ThemButton onClick={() => moveDashboard()}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <TodayTotalVolunteerList />
    </MainDiv>
  );
};

export default TodayAddVolunteerPage;
